<template>
 <div class="tab-container"   :style='{width: panelWidth}'>

    <!-- <el-tag>mounted times </el-tag>
    <el-alert :closable="false" style="width:200px;display:inline-block;vertical-align: middle;margin-left:30px;" title="Tab with keep-alive" type="success" /> -->
    <el-tabs v-model="activeClientName" type="border-card">

      <el-tab-pane v-for='item in panel.subMenu' :key='item.id' :name='item.id' :label='item.options.title' style='color: black;'>
        <keep-alive>
            <client-array ref="clientarray" :parentPanel='panel' v-if="activeClientName==item.id" :data='inData[item.id]' :panel='panel' @getDetail="getDetail" />
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane :lazy="true" :label='$t("Client Search")' name='clientSearch'>
        <lu-vbox style='padding: 20px;' >
          <el-form lu-flex ref="clientSearchForm" :model="clientSearchForm" label-width="120px">
            <el-form-item label="Env" style="width: 500px;">
              <el-input v-model="clientSearchForm.platform" clearable />
            </el-form-item>
            <el-form-item label="Client" style="width: 500px;">
              <el-input v-model="clientSearchForm.client" clearable />
            </el-form-item>
            <el-form-item label="Account" style="width: 500px;">
              <el-input v-model="clientSearchForm.account" clearable />
            </el-form-item>
            <el-form-item style="margin-top: 5px;">
              <el-button type="primary" icon="el-icon-check" @click="onSaveClientSearch">Save</el-button>
              <el-button style="margin-left: 5px" type="primary" @click="onClearClientSearch">Clear</el-button>
            </el-form-item>
          </el-form>
        </lu-vbox>
      </el-tab-pane>
    </el-tabs>
    <el-dialog class="centered" :append-to-body="false" :modal="false" title="Settings - Client Monitoring" :visible.sync="showDialog" @close='closeClientMonitoringDialog' width="30%">
      <lu-vbox lu-vcenter lu-hcenter lu-flex>
        <el-form ref='form' :model='form' lu-flex label-width="100px" :rules="rules" label-position="left">
          <el-form-item label="Env" prop="platform" required>
            <el-input v-model="form.platform" clearable />
          </el-form-item>
          <el-form-item label="Account" prop="account" required style="margin-top: 25px;">
            <el-input v-model="form.account" clearable />
          </el-form-item>
          <el-form-item style="margin-top: 30px;">
            <lu-hbox lu-hcenter lu-flex class='pad-in-5'>
              <el-button type="primary" @click="validateClientMonitoringDialog('addToClientList')">{{ $t('Add') }}</el-button>
              <el-button style="margin-left: 5px" @click="validateClientMonitoringDialog('removeFromClientList')">{{ $t('Remove') }}</el-button>
            </lu-hbox>
          </el-form-item>
        </el-form>
      </lu-vbox>
    </el-dialog>
  </div>
</template>

<script>
import { LuHbox, LuVbox } from 'lusis-ui'
import ClientArray from './clientArray'
import monitoringMixin from './mixins'

export default {
  name: 'ClientTab',
  components: { ClientArray, LuHbox, LuVbox },
  props: [ 'data', 'panel' ],
  mixins: [ monitoringMixin ],
  data() {
    return {
      activeClientName: 'TopWinningClient',
      showDialog: false,
      form: {
        platform: '',
        account: ''
      },
      rules: {
        platform: [
          { required: true, message: 'Please input Environment', trigger: 'blur' }
        ],
        account: [
          { required: true, message: 'Please input Account', trigger: 'blur' }
        ]
      },
      clientSearchForm: {
        platform: '',
        client: '',
        account: ''
      }
    }
  },
  computed: {
    inData: function () {
      return this.data ? this.data : {}
    }
  },
  watch: {
    activeClientName(val) {
      // eslint-disable-next-line
      this.$router.push(`${this.$route.path}?tabClient=${val}`).catch(err => {})
    }
  },
  created() {
    // init the default  selected tab
    const tab = this.$route.query.tabClient
    if (tab) {
      this.activeClientName = tab
    }
  },
  methods: {
    getDetail: function (params) {
      this.$emit('getDetail', params)
    },
    onExportExcel: function (sheetOnly,exportExcel='',exportExcelFilePrefix='', panelId='') {
      if (sheetOnly) {
        return this.$refs.clientarray[0].onExportExcel(sheetOnly,exportExcel,exportExcelFilePrefix, panelId)
      } else {
        let selectedTab = this.panel.subMenu.find(item => item.id === this.activeClientName)
        if (selectedTab != null)
          return this.$refs.clientarray[0].onExportExcel(sheetOnly,selectedTab.exportExcel,selectedTab.exportExcelFilePrefix, selectedTab.id)
      }
    },
    onSettings () {
      this.showDialog = true
      this.clearForm()
    },
    clearForm() {
      this.$refs.form.resetFields()
    },
    validateClientMonitoringDialog(functionId) {
      if (functionId === '') {
        return
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          const parameterList = [
            {
              'paramName':'platform',
              'paramValue': this.form.platform
            },
            {
              'paramName':'account',
              'paramValue': this.form.account
            }
          ]
          const cond = {
            MTI: 4989,
            functionId: functionId,
            parameterList: parameterList
          }
    
          this.$tango.request(cond).then(rep => {
            if (rep.resultCode === 0) {
              this.showDialog = false
              this.$message({
                message: 'Client Monitoring Settings updated successfully',
                type: 'success'
              })
            }
            else {
              this.showDialog = false
              this.$message({
                message: 'Client Monitoring Settings Error',
                type: 'error'
              })
            }
          }).catch(() => {
            this.showDialog = false
          })
        }
      })

    },
    closeClientMonitoringDialog() {
      this.showDialog = false
    },
    onSaveClientSearch: function () {
      const params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': 'platform', 'paramValue': this.clientSearchForm.platform},
        {'paramName': 'accountNumber', 'paramValue': this.clientSearchForm.account},
        {'paramName': 'account', 'paramValue': this.clientSearchForm.client}
      ]
      this.getDetail({title: this.panel.options.title, type: 'account', value: this.clientSearchForm.client, params: params, show: true})
    },
    onClearClientSearch: function () {
      this.clientSearchForm.platform = ''
      this.clientSearchForm.client = ''
      this.clientSearchForm.account = ''
    }
  }
}
</script>

<style lang='scss'>
  .tab-container {

    .el-tabs--border-card {
      // -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
      // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);

      .el-tabs__header {
        background: transparent;
        border: unset;

        .el-tabs__item,
        .el-tabs__item.is-active {
            border: unset;
            font-size:13px;
            font-weight: 400;
        }
      }

      .el-tabs__content {
        padding: unset;
      }
    }
  }
</style>